import { Marker, InfoWindow } from "@react-google-maps/api";
import React, { useState } from "react";
import schoolImg from "../assets/Images/school.png";
import SchoolHoverModal from "./SchoolHoverModal";
import { poleType, setCenterType } from "../types/customTypes";

const SchoolMarker:React.FC<propTypes> = (props: propTypes) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipHovered, setTooltipHovered] = useState(false);

    const showPoles = () => {
        props.setCenter({
            latitude: props.school.school_Latitude,
            longitude: props.school.school_Longitude,
            ...props.school,
        }, 17);
    };

    const mouseOut = () => {
        setTimeout(() => {
            if (!tooltipHovered) setShowTooltip(false);
        }, 300);
    };

    return (
        <div className="SchoolMarker">
          <Marker
              key={props.school.pole_id}
              onClick={showPoles}
              onMouseOver={() => { setShowTooltip(true); }}
              onMouseOut={mouseOut}
              position={{ lat: parseFloat(props.school.school_Latitude), lng: parseFloat(props.school.school_Longitude) }}
              icon={schoolImg}
            >
              {showTooltip
                    && (
                        <InfoWindow options={{ pixelOffset: new google.maps.Size(0,10) }}>
                            <SchoolHoverModal
                                onMouseOver={() => { setShowTooltip(true); setTooltipHovered(true); }}
                                onMouseOut={() => { setTooltipHovered(false); setShowTooltip(false); }}
                                school={props.school}
                                controlImageCreation={props.controlImageCreation}
                                getMapImage={props.getMapImage}
                                setCenter={props.setCenter}
                            />
                    </InfoWindow>
                    )}
            </Marker>
        </div>
    );
};

type propTypes = {
    setCenter: setCenterType,
    school: poleType,
	controlImageCreation : (a) => void,
    getMapImage: () => void
};

export default SchoolMarker;
